module.exports = __webpack_public_path__ + "media/images/emblems/Waedenswil-blazon-4d1288a9419bcdfaf8a65f8a1077a9d9.svg";